import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['product', 'questionGroup']

  connect() {
    this.productTargets.forEach(p => {
      p.addEventListener('change', (event) => {
        this.toggleQuestionGroups(p)
      })
    })
  }

  toggleQuestionGroups(product) {
    this.questionGroupTargets.forEach((group, i) => {
      if (i + 1 > (parseInt(product.value) || 0) + (parseInt(product.dataset.purchased) || 0)) {
        $(group).slideUp()
      } else {
        $(group).slideDown()
      }
    })
  }
}
